import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import {closestParent} from '../utils/dom';


const formControlTypes = ['multiselect'];


class FormControlMultiSelect extends React.Component {
    /* Renders a multiselect with Bootstrap 4 style list group where the selected options are rendered first.
     * After the user selects an option the multiselect's option is updated and parent form submitted (if it is found).
     */
    static propTypes = {
        domNode: PropTypes.shape({
            options: PropTypes.object.isRequired,
        }).isRequired,
    };

    static onOptionClick = (event, option) => {
        event.preventDefault();
        option.selected = !option.selected; // eslint-disable-line no-param-reassign
        const form = closestParent(option, 'form');
        if (form) {
            form.submit();
        }
    };

    render() {
        let options = [];
        for (let i = 0, len = this.props.domNode.options.length; i < len; i += 1) {
            options.push(this.props.domNode.options[i]);
        }
        options = options.sort((a, b) => {
            if (a.selected && !b.selected) {
                return -1;
            }
            if (b.selected && !a.selected) {
                return 1;
            }
            return 0;
        });

        const renderOption = (option) => {
            let className = 'list-group-item list-group-item-action d-flex justify-content-between align-items-center';
            if (option.selected) {
                className = `${className} active`;
            }
            return (
                <button
                    key={option.value}
                    type="button"
                    className={className}
                    onClick={e => FormControlMultiSelect.onOptionClick(e, option)}
                >
                    {option.text}
                    {option.selected ? <FontAwesomeIcon icon="check" /> : null}
                </button>
            );
        };

        return (
            <div className="list-group list-group-flush">
                {options.map(renderOption)}
            </div>
        );
    }
}


const renderFormControls = () => {
    /* Overrides form controls with specific React elements.
     * Form control type can be specified with `data-form` attribute on the wrapper. Note that you also need to:
     *   1) mark a child element with `data-form-container` - this is where the React element renders into
     *   2) mark the actual form control element inside of the wrapper with `data-form-control`
     *
     * It might be nice to hide the actual form control from UI (e.g. with .d-none).
     */
    for (let i = 0; i < formControlTypes.length; i += 1) {
        const formControlType = formControlTypes[i];
        const formControlWrappers = document.querySelectorAll(`[data-form="${formControlType}"]`);
        for (let j = 0; j < formControlWrappers.length; j += 1) {
            const formWrapper = formControlWrappers[j];
            const formControlContainer = formWrapper.querySelector('[data-form-container]');
            const formControl = formWrapper.querySelector('[data-form-control]');

            let component;
            switch (formControlType) {
                case 'multiselect':
                    component = <FormControlMultiSelect domNode={formControl} />;
                    break;
                default:
                    component = null;
                    break;
            }

            if (component) {
                ReactDOM.render(component, formControlContainer);
            }
        }
    }
};

export default renderFormControls;



// WEBPACK FOOTER //
// ./src/components/FormControl.js